import { render, staticRenderFns } from "./JEditor.vue?vue&type=template&id=80ec12ce"
import script from "./JEditor.vue?vue&type=script&lang=js"
export * from "./JEditor.vue?vue&type=script&lang=js"
import style0 from "./JEditor.vue?vue&type=style&index=0&id=80ec12ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports